export const SET_BANK_DETAILS = 'SET_BANK_DETAILS';
export const SET_FOLIO_DETAILS = 'SET_FOLIO_DETAILS';
export const GET_FOLIO_DETAILS = 'GET_FOLIO_DETAILS';
export const SET_FOLIO_VALUES = 'SET_FOLIO_VALUES';
